import type { ReactNode } from 'react'
import s from './Feedback.module.scss'

/**
 * Es lädt.
 *
 * `role="status"` sagt einem Bildschirmleser, dass sich hier etwas tut — sonst
 * bleibt die Seite für ihn stumm, bis die Daten da sind.
 */
export function Loading({ children = 'lädt …' }: { children?: ReactNode }) {
  return (
    <div className={s.loading} role="status">
      <span className={s.spinner} aria-hidden="true" />
      {children}
    </div>
  )
}

/**
 * Es gibt nichts zu zeigen.
 *
 * Mit Platz für einen Hinweis, was zu tun wäre: "keine Daten" allein lässt den
 * Leser ratlos, "keine Treffer — Suchbegriff kürzen" nicht.
 */
export function EmptyState({ title, children }: {
  title?: string
  children?: ReactNode
}) {
  return (
    <div className={s.empty}>
      {title && <span className={s.emptyTitle}>{title}</span>}
      {children}
    </div>
  )
}

/** Etwas ist schiefgegangen. `role="alert"` wird sofort vorgelesen. */
export function ErrorBox({ children }: { children: ReactNode }) {
  return <div className={s.error} role="alert">{children}</div>
}

/** Etwas ist einzuschränken, aber nicht kaputt. */
export function WarnBox({ children }: { children: ReactNode }) {
  return <div className={s.warn}>{children}</div>
}

/** Eine Nebenbemerkung unter einer Karte oder einem Feld. */
export function Note({ children }: { children: ReactNode }) {
  return <p className={s.note}>{children}</p>
}
